/**
 * Determines the target address space for fetch requests based on environment.
 *
 * targetAddressSpace is a Chrome-only API (Private Network Access).
 * Safari, Brave, and Firefox throw TypeError on unknown fetch options.
 *
 * In test and local development environments, services run on localhost (loopback).
 * In production, services run on VPN private IPs (local network).
 */
export function getTargetAddressSpace(): "loopback" | "local" | undefined {
  if (typeof Request === "undefined") {
    return undefined;
  }

  try {
    // Constructing a Request with an unknown option throws TypeError in
    // browsers that don't support it (Safari, Brave, Firefox).
    // Chrome accepts the option silently.
    new Request("data:,", { targetAddressSpace: "loopback" } as RequestInit);
  } catch {
    return undefined;
  }

  const testTypes = ["e2e_test", "pe2e_test"];
  const isTest = testTypes.includes(process.env.TEST_TYPE || "");
  const isLocalDev = process.env.NODE_ENV === "development";
  return isTest || isLocalDev ? "loopback" : "local";
}
